export const ignoreErrors = [
  // App errors
  /^Http failure response/,
  /ChunkLoadError/,
  /^NetworkError/,
  /chrome-extension/,
  /yaCounter/,
  /^Non-Error exception captured with keys/,
  /webgl/i,
  'object unsubscribed',
  'Timeout has occurred',
  'You must connect to the socket before sending any data',
  'Failed to start the audio device',
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  'Can\'t find variable: ZiteReader',
  'Cannot read properties of null (reading \'CodeMirror\')',
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  // Generic error code from errors outside the security sandbox
  // You can delete this if using raven.js > 1.0, which ignores these automatically.
  'Script error.',
  // Avast extension error
  '_avast_submit',
  // TODO debug this angular signals bug
  // null is not an object (evaluating 'a.trackingVersion')
  /trackingVersion/,
  /^Server returned code/,
  // spine
  'Cannot read properties of undefined (reading \'findRegion\')',
  /NG0203/, // Angular error code
  /NG0750/, // Angular error code
  /Java object is gone/i, // Android WebView bridge gone
  /Java bridge/i, // Generic Java bridge issues
  /evaluating ['"]this\.skeleton\.data['"]/i, // Safari "undefined is not an object"
  /evaluating ['"]this\.atlas\.findRegion['"]/i, // Safari "undefined is not an object"
  /JavaScript MIME type/i // MIME type mismatch/strict MIME type errors
];